import React from 'react';

import KPTable from '../../../../components/KPTComponents/KPTable';

import { ActionColumn } from '../../../../containers/DangKyHoSo/utils';
import { MONOGRAPH_MODEL, CRUD_MODELS } from '../../../../constants';
import { Chip } from '@mui/material';

function SachTable({ rows, setDialog, setDuyetThanhTich, ...props }) {
  const columns = [
    { key: 'orderNumber', width: setDuyetThanhTich ? '5%' : '10%', title: 'STT' },
    { ...MONOGRAPH_MODEL.title, width: '25%' },
    { ...MONOGRAPH_MODEL.phase, width: '15%',
      render: (value) => value === 'after' ? 'Sau' : 'Trước',
     },
     { ...MONOGRAPH_MODEL.publishedYear, width: '10%' },
    {
      ...MONOGRAPH_MODEL.type,
      width: '15%',
      align: 'center',
      render: (value) => MONOGRAPH_MODEL.type.options.find((e) => e.value === value)?.title,
	  },
    {
      ...MONOGRAPH_MODEL.role,
      align: 'center',
      width: '18%',
      render: (value) => MONOGRAPH_MODEL.role.options.find((e) => e.value === value)?.title,
	  },
  ];

  if (setDuyetThanhTich) {
    columns.push({
      key: "numberAuthor",
      label: "Số tác giả",
      align: 'center',
      width: '5%',
      render: (_, row) => row.numberAuthor,
    });
    columns.push({
      key: "numberMain",
      label: "Số chủ biên",
      align: 'center',
      width: '5%',
      render: (_, row) => row.numberMain,
    });
    columns.push({
      key: 'point',
      label: 'Điểm',
      align: 'center',
      width: '5%',
      render: (_, row) => row.scoringTable?.point
    });
    columns.push({
      key: "point",
      label: "Điểm tối đa",
      align: "center",
      width: "5%",
      render: (_, row) => row.scoringTable?.maxPoint,
    });
    columns.push({
      key: 'note',
      label: 'Ghi chú',
      align: 'center',
      width: '10%',
      render: (_, row) => row.scoringTable?.note
    });
    columns.push({
      key: 'accepted',
      label: 'Trạng thái',
      align: 'center',
      width: '15%',
      render: (_, row) => (
        <Chip
          size='small'
          color={(row.scoringTable?.accepted || row?.notEligible) ? 'primary' : 'default'}
          label={(row.scoringTable?.accepted || row?.notEligible) ? 'Đã chấm' : 'Chưa chấm'}
          variant={(row.scoringTable?.accepted || row?.notEligible) ? 'filled' : 'outlined'}
        />
      )
    });
  }

  columns.push({
    key: 'accepted',
    label: 'Tác vụ',
    width: '15%',
    render: (_, row) => (
      <ActionColumn
        row={row}
        type={CRUD_MODELS.MONOGRAPH}
        setDialog={setDialog}
        setDeleteCrud={props.setDeleteCrud}
        setDuyetThanhTich={setDuyetThanhTich}
        setPreview={props.setPreview}
        setChoDiem={props.setChoDiem}
      />
    )
  });
  // console.log('SachTable', rows);

  return (
    <>
      <KPTable
        columns={columns}
        nonBorder={!!props.nonBorder}
        rows={rows}
        // loading={loading}
      />
      {/* count number of book has role == main and phase == after */}
      {rows?.filter((row) => row.role === 'main' && row.phase === 'after').length >= 0 && (
        <div style={{ margin: '0px 16px 16px 16px' }}>
          <Chip
            label={`Số lượng sách ứng viên là chủ biên sau PSG/TS: ${rows?.filter((row) => row.role === 'main' && row.phase === 'after').length}`}
            color='primary'
          />
        </div>
      )}
    </>
  );
}

export default SachTable;
